var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogContainer",
    {
      attrs: {
        showDialog: _vm.showDialog,
        title: "Add Equipment",
        icon: "add",
        toolbarActions: [
          {
            text: "Save",
            icon: "save",
            buttonColor: "success",
            emitEvent: "onSubmitClicked",
            showIsLoading: true,
            isDisabledFunc: () => !_vm.isFormValid,
          },
          {
            text: "Cancel",
            depressed: true,
            emitEvent: "onCancelClicked",
          },
        ],
        isLoading: _vm.isLoading,
      },
      on: {
        onCancelClicked: _vm.onCancelClicked,
        onSubmitClicked: _vm.onSubmitClicked,
      },
    },
    [
      _c(
        "v-container",
        { attrs: { "pa-0": "", "grid-list-lg": "" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.isFormValid,
                callback: function ($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid",
              },
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlSlider", {
                        attrs: {
                          label: "Count",
                          max: 10,
                          min: 1,
                          disabled: _vm.isLoading,
                        },
                        model: {
                          value: _vm.count,
                          callback: function ($$v) {
                            _vm.count = $$v
                          },
                          expression: "count",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(_vm.count, function (key, index) {
                          return _c(
                            "v-flex",
                            {
                              key: key,
                              class: { md6: _vm.count > 1 },
                              attrs: { xs12: "" },
                            },
                            [
                              _c("ControlTextField", {
                                attrs: {
                                  label: key + ") Equipment Serial/Id*",
                                  disabled: _vm.isLoading,
                                  rules: [(v) => !!v || "Required"],
                                },
                                model: {
                                  value: _vm.assetNames[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.assetNames, index, $$v)
                                  },
                                  expression: "assetNames[index]",
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledLocationList,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Location*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.locationId,
                          callback: function ($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledClientList,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Owner*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.clientId,
                          callback: function ($$v) {
                            _vm.clientId = $$v
                          },
                          expression: "clientId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledCategoryList,
                          autocomplete: "",
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                          label: "Category*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        on: {
                          change: function ($event) {
                            _vm.modelId = null
                          },
                        },
                        model: {
                          value: _vm.categoryId,
                          callback: function ($$v) {
                            _vm.categoryId = $$v
                          },
                          expression: "categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.enabledManufacturerList,
                          autocomplete: "",
                          "item-text": "name",
                          "item-value": "id",
                          clearable: "",
                          label: "Manufacturer*",
                          disabled: _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        on: {
                          change: function ($event) {
                            _vm.modelId = null
                          },
                        },
                        model: {
                          value: _vm.manufacturerId,
                          callback: function ($$v) {
                            _vm.manufacturerId = $$v
                          },
                          expression: "manufacturerId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlAutoComplete", {
                        attrs: {
                          items: _vm.modelListByCategoryAndManufacturer,
                          "item-text": "name",
                          "item-value": "id",
                          label: _vm.modelLabel,
                          disabled:
                            !_vm.categoryId ||
                            !_vm.manufacturerId ||
                            !_vm.modelListByCategoryAndManufacturer.length ||
                            _vm.isLoading,
                          rules: [(v) => !!v || "Required"],
                        },
                        model: {
                          value: _vm.modelId,
                          callback: function ($$v) {
                            _vm.modelId = $$v
                          },
                          expression: "modelId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("ControlTextArea", {
                        attrs: { label: "Comments", disabled: _vm.isLoading },
                        model: {
                          value: _vm.comments,
                          callback: function ($$v) {
                            _vm.comments = $$v
                          },
                          expression: "comments",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("small", [_vm._v("*indicates required field")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }